export enum CultureStatus {
    Active = "ACTIVE",
    Dead = "DEAD",
    Moved = "MOVED",
    Done = "DONE"
}